import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { IInventory } from 'partsOld/types';

export const getMany = async (
  requestPayload: IRequestPayload
): Promise<GetManyResponse<IInventory>> => {
  const { data } = await partfinitiClient.get(
    `/inventory/item/items?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`
  );

  return mapRecordsFromServer<IInventory>(data.data, data.recordsFiltered, data.totals);
};
